<template>
	<div>
		<div
			style="width: 210px;padding-top: 9px;padding-bottom: 9px;font-size: 14px;margin: auto;text-align: center;background-color: #aaa7a7;border-radius: 10px 10px 0px 0px;border-bottom: solid 1px #c6c6c6;">
			{{selectdItem.compontChildren[0].name + '设置'}}
		</div>
		<div class="item">
			<div>代码输入框</div>
		</div>
		<div class="item">
			<el-input type="textarea" :rows="5" placeholder="请输入内容"
				v-model="selectdItem.compontChildren[0].data.code">
			</el-input>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			all_setting: {
				type: Array,
				default: []
			},
			goodsData: {
				type: Object,
				default: () => {
					return {}
				}
			},
			equipment: {
				type: String,
				default: "pc"
			},
			fontList: {
				type: Array,
				default: []
			},
			selectdItem: {
				type: Object,
				default: () => {
					return {}
				}
			},
			systemConfig: {
				type: Object,
				default: () => {
					return {}
				}
			},
			type: {
				type: String,
				default: "design"
			},
		},
	}
</script>

<style scoped lang="scss">
	.item {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin: 6px;
	}

	input:focus {
		outline: none;
		border: 1px solid #242754;
		border-radius: 3px;
	}

	input {
		outline: none;
		border: 1px solid #c1c1c1;
		border-radius: 5px;
	}

	.tit-icon:hover {
		color: #8c62ff;
	}
</style>